module.exports = __webpack_public_path__ + "static/media/dummy-onbarding.3d719b66.png";